





































































































































































import { Pagination } from '@/common';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { PaymentListSearchDto, PaymentListDto } from '../../../dto';
import PaymentListService from '../../../services/payment-list.service';

@Component({
  name: 'PaymentListSearch',
})
export default class PaymentListSearch extends BaseComponent {
  private paymentListSearchDto = new PaymentListSearchDto();
  private pagination = new Pagination();
  private paymentTotalCount = null;
  private paymentList: PaymentListDto[] = [];
  private dataLoading = true;
  private totalRevenue = null;

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.paymentListSearchDto = new PaymentListSearchDto();
      this.findAll();
    }
    this.totalRevenue = null;
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.paymentListSearchDto, this.pagination);
    }
    PaymentListService.findAll(
      this.paymentListSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.paymentList = res.data.items;
        this.paymentTotalCount = res.data.totalCount;
        this.dataLoading = false;
      }
      this.findRevenue();
    });
  }

  findRevenue() {
    this.totalRevenue = null;
    const newPaymentListSearchDto = new PaymentListSearchDto();
    newPaymentListSearchDto.started = this.paymentListSearchDto.started;
    newPaymentListSearchDto.nanudaKitchenMasterName = this.paymentListSearchDto.nanudaKitchenMasterName;
    newPaymentListSearchDto.totalAmount = this.paymentListSearchDto.totalAmount;
    newPaymentListSearchDto.nanudaKitchenMenuName = this.paymentListSearchDto.nanudaKitchenMenuName;
    if (newPaymentListSearchDto.started) {
      PaymentListService.findRevenue(newPaymentListSearchDto).subscribe(res => {
        this.totalRevenue = res.data.sum;
      });
    }
  }

  created() {
    this.paymentListSearchDto.started = new Date().toISOString().substr(0, 10);

    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.paymentListSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
  }
}
